import React, { useEffect, useRef, useState } from "react";
import {
	Button,
	Col,
	Form,
	Modal,
	Overlay,
	Popover,
	Row,
	Tooltip,
} from "react-bootstrap";
import { customStyles } from "../../selectStyles";
import ReactSelect from "react-select";
import { useDispatch, useSelector } from "react-redux";
import { clearCityList, fetchCityData, selectCity } from "../../redux/actions/citiesAction";
import { fetchJobType, selectJobType } from "../../redux/actions/jobTypeAction";
import CloseSharpIcon from "@mui/icons-material/CloseSharp";
// import ReactQuill from "react-quill";

import {
	fetchWorkLevelTypeData,
	selectWorkLevel,
} from "../../redux/actions/workLevelTypeAction";
import {
	fetchWorkLocationTypeData,
	selectLocationType,
	selectWorkLocation,
} from "../../redux/actions/workLLocationTypeAction";
import {
	fetchDesignation,
	selectDesignation,
} from "../../redux/actions/designationAction";
import {
	fetchSalaryType,
	selectSalaryType,
} from "../../redux/actions/salaryTypeAction";
import toast from "react-hot-toast";
import axios from "../../API/axios";
import { useNavigate } from "react-router-dom";
// import ExcelFile from "../../assets/Wok.xlsx";
import ExcelFile from "../../assets/excelkhoj/Job Post Bulk Upload Sample.xlsx";
import { fetchCompanySizeData } from "../../redux/actions/companySizeActions";
import { fetchAllOrgsData } from "../../redux/actions/getAllOrgsAction";
import { fetchCompanyData } from "../../redux/actions/getCompaniesAction";
import { fetchCurrency } from "../../redux/actions/getcurrencyAction";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css"; // Import styles


const PostCard = () => {
	const navigate = useNavigate();
	// ...............................Post Job Start.......................................
	const sessionId = localStorage.getItem("sessionId");
	const UserType = localStorage.getItem("userType");
	const companyUId = localStorage.getItem("userUID");
	const [images, setImages] = useState([]);
	const [display, setDisplay] = useState(false);
	const [minimumSalary, setMinimumSalary] = useState("");
	const [maximumSalary, setMaximumSalary] = useState("");
	const [jobTitle, setJobTitle] = useState("");
	const [requirement, setRequirement] = useState("");
	const [jobDescription, setjobDescription] = useState("");
	const [InsName, setInsName] = useState("");

	const [isChecked, setIsChecked] = useState(false)

	const handleImageUpload = (e) => {
		const files = Array.from(e.target.files);
		setImages(files);
	};

	const removeImage = (index) => {
		setImages(images.filter((_, i) => i !== index));
	};

	// .......................... Edit-Candid Disabled and Enabaled
	const [formChanged, setFormChanged] = useState(false);
	const [isSubmitting, setIsSubmitting] = useState(false);

	const stripHtmlTags = (html) => {
		const doc = new DOMParser().parseFromString(html, "text/html");
		return doc.body.textContent || "";
	};

	const handleFieldChange = (setter, value, fieldName) => {
		// ReactQuill ka data properly clean karein
		const cleanedValue = fieldName === "jobDescription" || fieldName === "requirement"
			? stripHtmlTags(value)
			: value;

		setter(value); // State update karein original value ke saath

		// Convert non-string values to empty strings
		const updatedJobTitle = fieldName === "jobTitle" ? cleanedValue : jobTitle || "";
		const updatedMinimumSalary = fieldName === "minimumSalary" ? cleanedValue : minimumSalary || "";
		const updatedMaximumSalary = fieldName === "maximumSalary" ? cleanedValue : maximumSalary || "";
		const updatedCurrency = fieldName === "currency" ? cleanedValue : currency || "";
		const updatedSalaryTypeSearch = fieldName === "salaryTypeSearch" ? cleanedValue : salaryTypeSearch || "";
		const updatedDesignationSearch = fieldName === "designationSearch" ? cleanedValue : designationSearch || "";
		const updatedWorkLevelSearch = fieldName === "workLevelSearch" ? cleanedValue : workLevelSearch || "";
		const updatedWorkLocationSearch = fieldName === "workLocationSearch" ? cleanedValue : workLocationSearch || "";
		const updatedJobTypeSearch = fieldName === "jobTypeSearch" ? cleanedValue : jobTypeSearch || "";
		const updatedCityListSearch = fieldName === "cityListSearch" ? cleanedValue : cityListSearch || "";
		const updatedRequirement = fieldName === "requirement" ? cleanedValue : requirement || "";
		const updatedJobDescription = fieldName === "jobDescription" ? cleanedValue : jobDescription || "";

		// Validate all required fields
		const isValid =
			updatedJobTitle.trim() !== "" &&
			updatedMinimumSalary !== "" &&
			updatedMaximumSalary !== "" &&
			Number(updatedMaximumSalary) >= Number(updatedMinimumSalary) && // Ensure max salary is greater than min salary
			updatedCurrency.trim() !== "" &&
			updatedSalaryTypeSearch?.toString().trim() !== "" &&
			updatedDesignationSearch?.toString().trim() !== "" &&
			updatedWorkLevelSearch?.toString().trim() !== "" &&
			updatedWorkLocationSearch?.toString().trim() !== "" &&
			updatedJobTypeSearch?.toString().trim() !== "" &&
			updatedCityListSearch?.toString().trim() !== "" &&
			updatedRequirement.trim() !== "" &&
			updatedJobDescription.trim() !== "";

		setFormChanged(isValid);
	};

	// ..............................  Edit-Candid Disabled and Enabaled

	// .............................. Bulk upload excel file  Enabled 
	const [formChangedBulk, setFormChangedBulk] = useState(false); // Track if form is modified
	const [isSubmittingBulk, setIsSubmittingBulk] = useState(false);
	const [uploadedFile, setUploadedFile] = useState(null); // Track uploaded file

	// Handle changes and mark form as modified
	const handleFieldChangeBulk = (setter, value, fieldName) => {
		setter(value);
		if (fieldName === "fileUpload") {
			handleFileUpload(value);
		} else {
			validateForm(fieldName, value);
		}
	};

	// Function to check if all required fields are filled
	const validateForm = (fieldName, value) => {
		// const updatedCompanyAssoListId = fieldName === "companyAssoListId" ? value : companyAssoListIdBulk;
		const updatedFile = fieldName === "fileUpload" ? value : uploadedFile;

		if (updatedFile) {
			setFormChangedBulk(true);
		} else {
			setFormChangedBulk(false);
		}
	};

	// .............................. Bulk upload excel file  Disabled 

	const AddJobCompany = async () => {
		setDisplay(true);
		setIsSubmitting(true); // Disable the button during submission
		setIsSubmittingBulk(true)
		const body = {
			sessionId: sessionId,
			compType: UserType,
			compUid: companyUId,
			cityId: cityListSearch,
			jbTypId: jobTypeSearch,
			workLevelType: workLevelSearch,
			workLocationType: workLocationSearch,
			DesignationName: designationSearch,
			salaryTypeId: salaryTypeSearch,
			minSalary: minimumSalary,
			maxSalary: maximumSalary,
			currency: currency,
			title: jobTitle,
			description: jobDescription,
			requirement: requirement,
		};
		console.log("body", body);

		if (
			cityListSearch === "" ||
			jobTypeSearch === "" ||
			workLevelSearch === "" ||
			workLocationSearch === "" ||
			designationSearch === "" ||
			salaryTypeSearch === "" ||
			minimumSalary === "" ||
			maximumSalary === "" ||
			requirement === "" ||
			currency === "" ||
			jobTitle === "" ||
			jobDescription === ""
		) {
			toast.error("Please fill all the required fields");
			setIsSubmitting(false); // Re-enable the button if validation fails
			setIsSubmittingBulk(false); // Re-enable the button if validation fails
		} else if (Number(maximumSalary) < Number(minimumSalary)) {
			toast.error("Maximum Salary cannot be less than Minimum Salary");
			setIsSubmitting(false);
			setIsSubmittingBulk(false);
		}

		else {
			try {
				const res = await axios.post("/Job/AddJob", body);
				toast.success(res.data.message);
				setSalaryTypeSearch();
				setDesignationSearch("");
				setworkLocationSearch("");
				setworkLevelSearch("");
				setjobTypeSearch("");
				setcityListSearch("");
				setMinimumSalary("");
				setMaximumSalary("");
				setJobTitle("");
				setCurrency("")
				setFormChanged(false); // Disable the button after successful update

				navigate("/job/My-Jobs");
			} catch (error) {
				if (error.response && error.response.status === 404) {
					toast.error(error.response.data.message);
				} else {
					toast.error(error.response?.data?.message || "An error occurred");
				}
			} finally {
				setIsSubmitting(false); // Ensure the button is re-enabled in case of failure
				setIsSubmittingBulk(false); // Ensure the button is re-enabled in case of failure
			}
		}
	};

	const dispatch = useDispatch();

	// Fetch jobtype data on component mount
	const [salaryTypeSearch, setSalaryTypeSearch] = useState("");
	const { salaryTypeList, selectedSalaryTypeId } = useSelector(
		(state) => state.salaryType
	);

	useEffect(() => {
		dispatch(fetchSalaryType());
	}, [dispatch]);

	const handleSalaryType = (selectedOption) => {
		if (selectedOption) {
			// dispatch(selectSalaryType(selectedOption.value));
			setSalaryTypeSearch(selectedOption.value);
		} else {
			setSalaryTypeSearch(null);
		}
	};
	// ...............................Salary Dropdown.......................................

	// ...............................Designation Dropdown.......................................
	const [designationSearch, setDesignationSearch] = useState("");

	const { designationList, selectedDesignationId } = useSelector(
		(state) => state.designation
	);
	// console.log('DESIGNATION',designationList,selectedDesignationId);

	useEffect(() => {
		dispatch(fetchDesignation());
	}, [dispatch]);

	const handleDesignation = (selectedOption) => {
		if (selectedOption) {
			// dispatch(selectDesignation(selectedOption.value));
			setDesignationSearch(selectedOption.value);
		} else {
			setDesignationSearch(null);
		}
	};
	// ...............................Designation Dropdown.......................................

	// ...............................Location Dropdown.......................................
	const [workLocationSearch, setworkLocationSearch] = useState("");

	const { workLocation, selectedCategoryId } = useSelector(
		(state) => state.workLocationType
	);
	useEffect(() => {
		dispatch(fetchWorkLocationTypeData());
	}, [dispatch]);

	const handleWorkLoc = (selectedOption) => {
		if (selectedOption) {
			// dispatch(selectWorkLocation(selectedOption.label));
			setworkLocationSearch(selectedOption.value);
		} else {
			setworkLocationSearch(null);
		}
	};
	// ...............................Location Dropdown.......................................

	// ...............................Work Level Dropdown.......................................
	// Fetch work level data on component mount
	const [workLevelSearch, setworkLevelSearch] = useState("");
	const { workLevelList, selectedworkLevelId } = useSelector(
		(state) => state.workLevelType
	);
	// console.log('Work Level', workLevelList, selectedworkLevelId);

	useEffect(() => {
		dispatch(fetchWorkLevelTypeData());
	}, [dispatch]);

	const handleWorkLevel = (selectedOption) => {
		if (selectedOption) {
			// dispatch(selectWorkLevel(selectedOption.value));
			setworkLevelSearch(selectedOption.value);
		} else {
			setworkLevelSearch(null);
		}
	};

	// ...............................Work Level Dropdown.......................................

	// ...............................Job Type Dropdown.......................................
	// Fetch jobtype data on component mount
	const [jobTypeSearch, setjobTypeSearch] = useState("");
	const { jobTypeList, selectedJobTypeId } = useSelector(
		(state) => state.jobType
	);

	useEffect(() => {
		dispatch(fetchJobType());
	}, [dispatch]);

	const handleJobType = (selectedOption) => {
		if (selectedOption) {
			// dispatch(selectJobType(selectedOption.value));
			setjobTypeSearch(selectedOption.value);
		} else {
			setjobTypeSearch(null);

		}
	};
	// ...............................Job Type Dropdown.......................................

	// ...............................City Dropdown.......................................

	const [neworgType, setneworgType] = useState("");
	const [neworgId, setneworgId] = useState("");
	const [orgCity, setOrgCity] = useState(null);
	const [cityListSearch, setcityListSearch] = useState("");
	const { cityList, selectedcityId } = useSelector((state) => state.cities);

	useEffect(() => {
		dispatch(fetchCityData());
		return () => {
			dispatch(clearCityList())
		}
	}, [dispatch]);
	const handleCityInputChange = (inputValue) => {
		console.log("inputValue", inputValue);

		dispatch(fetchCityData(inputValue));
	};

	const handleCitySelect = (selectedOption) => {
		if (selectedOption) {
			setcityListSearch(selectedOption.value);
		} else {
			setcityListSearch(null);

		}
	};
	const handleCitySelect1 = (selectedOption) => {
		if (selectedOption) {
			setOrgCity(selectedOption.value);
		}
	};

	const [fileName, setFileName] = useState("Wok.xlsx");
	const [selectedFile, setSelectedFile] = useState(null);

	const [showBulkModal, setShowBulkModal] = useState(false);
	const handleShowBulkModal = () => setShowBulkModal(true);
	const handleCloseBulkModal = () => {
		setShowBulkModal(false);
		resetModalState()
	};

	const resetModalState = () => {
		setIsSubmitting(false);
		setUploadedFile(null);
		setIsChecked(false);
		setFormChangedBulk(false);
	};

	const downloadExcel = () => {
		const link = document.createElement("a");
		link.href = ExcelFile;
		link.download = fileName;
		link.click();
	};

	const handleFileUpload = (e) => {
		const file = e.target.files[0];
		setUploadedFile(file);
		validateForm("fileUpload", file);
		if (file) {
			setFileName(file.name);
			setSelectedFile(file);
		}
	};
	//const handleFileUpload = (e) => {
	// const file = e.target.files[0];
	// setUploadedFile(file);
	// validateForm("fileUpload", file);
	// if (!file) return;
	// const allowedTypes = [
	// 	"application/vnd.ms-excel",
	// 	"application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
	// 	"application/vnd.google-apps.spreadsheet"
	// ];

	// if (!allowedTypes.includes(file.type)) {
	// 	toast.error("Only Excel and Google Sheets files are allowed!");
	// 	e.target.value = ""; // Reset the file input
	// 	return;
	// }
	// setSelectedFile(file)
	// if (file) {
	// 	setFileName(file.name);
	// 	setSelectedFile(file);
	// }
	//};

	// const uploadFile = () => {
	// 	setIsSubmittingBulk(true)
	// 	const body = {
	// 		sessionId: sessionId,

	// 	};
	// 	console.log("body", body);

	// 	if (
	// 		""
	// 	) {
	// 		toast.error("Please fill all the required fields");
	// 		setIsSubmittingBulk(false); // Re-enable the button if validation fails
	// 	} else if (Number(maximumSalary) < Number(minimumSalary)) {
	// 		toast.error("Maximum Salary cannot be less than Minimum Salary");
	// 		setIsSubmittingBulk(false);
	// 	}



	// 	if (!selectedFile) {
	// 		alert("Please select a file to upload!");
	// 		return;
	// 	}

	// 	const formData = new FormData();
	// 	formData.append("file", selectedFile);

	// 	console.log("Uploading file:", selectedFile.name);
	// };

	const [isDownloading, setIsDownloading] = useState(false);

	const uploadFile = async (e) => {
		e.preventDefault();
		setIsDownloading(true);
		try {
			//setDisplay(true);
			setIsSubmitting(true);
			{
				const formData = new FormData();
				formData.append("File", uploadedFile);
				formData.append("SessionId", sessionId);

				console.log("Profile FormData:", formData);

				// First API call to submit the profile data
				const res = await axios.post(`/Job/BulkUploadByCompany?DuplicateSkip=${duplicateSkip}`, formData, {
					headers: {
						"Content-Type": "multipart/form-data",
					},
				});

				console.log("Profile Response:", res);
				toast.success(res.data.message);
				handleCloseBulkModal()
				setSelectedFile(null)
				setIsChecked(false);
				setIsDownloading(false);
			}
		} catch (error) {
			if (error.response.status === 400) {
				toast.error(error.response?.data.message)
				setIsDownloading(false);
			} else {
				toast.error(error.response?.data.title);
				setIsDownloading(false);

			}
			console.error(error)
		} finally {
			setIsSubmitting(false);
		}
	};


	// ...............................City Dropdown.......................................

	// ...............................Organization Dropdown.......................................

	//   Get organization
	const [getallorgsId, setGetAllOrgsId] = useState("");
	const [orgType, setOrgType] = useState("");
	const { getallorgsList, selectedgetallId } = useSelector(
		(state) => state.getallorgs
	);
	useEffect(() => {
		dispatch(fetchAllOrgsData());
	}, [dispatch]);

	const handleOrganization = (selectedOption) => {
		if (selectedOption) {
			setGetAllOrgsId(selectedOption.value);
			setOrgType(selectedOption.tagId);
		}
	};

	// ...............................Organization Dropdown.......................................

	// ...............................Company Category DDL.......................................
	// const [orgType, setOrgType] = useState("");
	const [companyListId, setCompanyListId] = useState("");
	const { getcompaniesList, selectedcompaniesId } = useSelector(
		(state) => state.getcompanies
	);

	useEffect(() => {
		dispatch(fetchCompanyData());
	}, [dispatch]);

	const handleSelectCompany = (selectedOption) => {
		console.log("selectedOption", selectedOption);

		if (selectedOption) {
			// dispatch(selectGetCompanies(selectedOption.value));
			setCompanyListId(selectedOption.value);
			setOrgType(selectedOption.tag);
		}
	};
	// const [getOrgInsTId, setGenOrgInstId] = useState(null);
	// ...............................Company Category DDL.......................................

	// ...............................currency Dropdown.......................................

	const [currency, setCurrency] = useState("");

	const { currencyList, selectedcurrencyId } = useSelector(
		(state) => state.currency
	);
	useEffect(() => {
		dispatch(fetchCurrency());
	}, [dispatch]);

	const handleCurrency = (selectedOption) => {
		if (selectedOption) {
			setCurrency(selectedOption.label);
		}
	};

	const handleFileChange = (event) => {
		const file = event.target.files[0]; // Get the selected file
		if (file) {
			setFileName(file.name); // Set the filename in state
		}
	};
	// ...................toolTip...............
	const [showTooltip, setShowTooltip] = useState(false);
	const targetRef = useRef(null);

	const toggleTooltip = () => {
		console.log("Toggling Tooltip");
		setShowTooltip((prev) => !prev);
	};

	const designationInputChange = (inputValue, { action }) => {
		if (action === "input-change") {
			console.log("Typed value:", inputValue); // Check if typing is detected
			setDesignationSearch(inputValue);
		}
	};
	const [duplicateSkip, setDuplicateSkip] = useState(false);
	const handleToggle = (e) => {
		setDuplicateSkip(e.target.checked);
	};
	// ...............................company Dropdown.......................................

	return (
		<>
			<div className="main-container mb-5 postJob">
				<div className="content-wrapper">
					<div className="title delete-title d-flex justify-content-between align-items-center Title-header-Mobile post-new-job-title">
						<h1 className="orange-title">
							<span className="orange-box"></span> Post A New Job
						</h1>
						<Button className="mainBtn apply-job ms-2 py-0 bulk-upload-btn"
							onClick={() => {
								handleShowBulkModal()
							}}>
							Bulk upload
						</Button>
					</div>

					<div className="card Alertcard PostCard">
						{/* ....................... 1 Row ......................... */}
						<div className="post-job-details-form p-0 ">
							<div className="post-form-row my-0 pt-3">
								<div className="post-form-group placeholder-from-react-select">
									<label htmlFor="about">
										Job Title <span style={{ color: "red" }}>*</span>
									</label>
									<input
										type="text"
										placeholder="Job Title"
										value={jobTitle}
										// onChange={(e) => setJobTitle(e.target.value)}
										// onChange={(e) => handleFieldChange(setJobTitle, e.target.value)}
										onChange={(e) => handleFieldChange(setJobTitle, e.target.value, "jobTitle")}
										onPaste={(e) => handleFieldChange(setJobTitle, e.clipboardData.getData("text"), "jobTitle")}
									/>
									{display && !jobTitle ? (
										<span className="error_msg_lbl">Enter Job Title</span>
									) : null}
								</div>

								<div className="post-form-group placeholder-from-react-select currency-input-from">
									<label htmlFor="about">
										Currency <span className="text-danger">*</span>
									</label>
									<ReactSelect
										// options={currencyList}
										options={currencyList.map(option => ({
											...option,
											label: option.label.toUpperCase() // Convert label to uppercase
										}))}
										// onChange={handleCurrency}
										// onChange={(option) => handleFieldChange(setCurrency, option ? option.label : "")}
										onChange={(option) => handleFieldChange(setCurrency, option ? option.label : "", "currency")}
										// value={
										//   currencyList.find(
										//     (option) => option.label === currency
										//   ) || null
										// }
										value={
											currencyList
												.map(option => ({ ...option, label: option.label.toUpperCase() })) // Ensure matching uppercase options
												.find(option => option.label === currency) || null
										}
										placeholder="Select Currency"
										styles={customStyles}
										classNamePrefix="react-select"
										className="form-control"
										isClearable
									// onInputChange={(inputValue) => setSalaryTypeSearch(inputValue)}
									// invalid={display && salaryTypeSearch === ""}
									/>

									{display && !currency ? (
										<span className="error_msg_lbl">Select Currency </span>
									) : null}
								</div>

							</div>
						</div>

						{/* ....................... 2 Row ......................... */}

						<div className="post-job-details-form p-0">
							<div className="post-form-row my-0">
								<div className="post-form-group placeholder-from-react-select">
									<label htmlFor="about">
										Minimum Salary <span style={{ color: "red" }}>*</span>
									</label>
									<input
										type="number"
										placeholder="Type Salary"
										value={minimumSalary}
										// onChange={(e) => handleFieldChange(setMinimumSalary, e.target.value)}
										onChange={(e) => handleFieldChange(setMinimumSalary, e.target.value, "minimumSalary")}
										onPaste={(e) => handleFieldChange(setMinimumSalary, e.clipboardData.getData("text"), "minimumSalary")}
									/>
									{display && !minimumSalary && (
										<span className="error_msg_lbl">Enter Minimum Salary</span>
									)}
								</div>

								<div className="post-form-group placeholder-from-react-select">
									<label htmlFor="about">
										Maximum Salary <span style={{ color: "red" }}>*</span>
									</label>
									<input
										type="number"
										placeholder="Type Salary"
										value={maximumSalary}
										// onChange={(e) => handleFieldChange(setMaximumSalary, e.target.value)}
										onChange={(e) => handleFieldChange(setMaximumSalary, e.target.value, "maximumSalary")}
										onPaste={(e) => handleFieldChange(setMaximumSalary, e.clipboardData.getData("text"), "maximumSalary")}
									/>
									{display && !maximumSalary && (
										<span className="error_msg_lbl">Enter Maximum Salary</span>
									)}
									{maximumSalary && minimumSalary && Number(maximumSalary) < Number(minimumSalary) && (
										<span className="error_msg_lbl">Maximum Salary cannot be less than Minimum Salary</span>
									)}
								</div>
							</div>


							{/* ....................... 3 Row ......................... */}

							<div className="post-form-row my-0">
								{/* ........Salary Type........ */}

								<div className="  post-form-group placeholder-from-react-select">
									<label htmlFor="about">
										Salary Type <span className="text-danger">*</span>
									</label>
									<ReactSelect
										options={salaryTypeList}
										// onChange={handleSalaryType}
										// onChange={(option) => handleFieldChange(setSalaryTypeSearch, option ? option.value : "")} // Track changes
										onChange={(option) => handleFieldChange(setSalaryTypeSearch, option ? option.value : "", "salaryTypeSearch")}
										value={
											salaryTypeList.find(
												(option) => option.value === salaryTypeSearch
											) || null
										}
										placeholder="Select Salary Type"
										styles={customStyles}
										classNamePrefix="react-select"
										className="form-control"
										isClearable
									// onInputChange={(inputValue) => setSalaryTypeSearch(inputValue)}
									// invalid={display && salaryTypeSearch === ""}
									/>

									{display && !salaryTypeSearch ? (
										<span className="error_msg_lbl">Select Salary Type </span>
									) : null}
								</div>

								{/* ........Designation........ */}

								<div className="post-form-group placeholder-from-react-select">
									<label htmlFor="externalUrl">Designation <span className="text-danger">*</span></label>
									{/* <ReactSelect
                    options={designationList}
                    // onChange={handleDesignation}
                    onChange={(option) => handleFieldChange(setDesignationSearch, option ? option.label : "")} // Track changes
                    value={
                      designationList.find(
                        (option) => option.label === designationSearch
                      ) || null
                    }
                    placeholder="Select Designation"
                    styles={customStyles}
                    classNamePrefix="react-select"
                    className="form-control"
                    isClearable
                  // onInputChange={(inputValue) => setDesignationSearch(inputValue)}
                  // invalid={display && designationSearch === ""}
                  /> */}
									<ReactSelect
										options={designationList}
										onInputChange={designationInputChange}
										// onChange={(option) => handleFieldChange(setDesignationSearch, option ? option.label : "")} // Track changes
										onChange={(option) => handleFieldChange(setDesignationSearch, option ? option.label : "", "designationSearch")}
										value={
											designationList.find((option) => option.label === designationSearch) ||
											(designationSearch ? { label: designationSearch, value: designationSearch } : null)
										}
										placeholder="Select Designation"
										styles={customStyles}
										classNamePrefix="react-select"
										className="form-control"
										isClearable
									/>
									{display && !designationSearch ? (
										<span className="error_msg_lbl text-red">
											Enter Designation
										</span>
									) : null}
								</div>
							</div>

							{/* ....................... 4 Row ........................ */}

							{/* ........Work level type........ */}

							<div className="post-form-row my-0">
								<div className="post-form-group post-form-fontPcard placeholder-from-react-select">
									<label htmlFor="about">
										Work Level Type <span className="text-danger ">*</span>
									</label>
									<ReactSelect
										options={workLevelList}
										// onChange={handleWorkLevel}
										// onChange={(option) => handleFieldChange(setworkLevelSearch, option ? option.value : "")} // Track changes
										onChange={(option) => handleFieldChange(setworkLevelSearch, option ? option.value : "", "workLevelSearch")}
										value={
											workLevelList.find(
												(option) => option.value === workLevelSearch
											) || null
										}
										placeholder="Select Work Level Type"
										styles={customStyles}
										classNamePrefix="react-select"
										className="form-control"
										isClearable
									// onInputChange={(inputValue) => setworkLevelSearch(inputValue)}
									// invalid={display && workLevelSearch === ""}
									/>
									{display && !workLevelSearch ? (
										<span className="error_msg_lbl">
											Select Work Level Type{" "}
										</span>
									) : null}
								</div>

								{/* ........Work location type........ */}

								<div className="post-form-group post-form-fontPcard placeholder-from-react-select">
									<label htmlFor="about">
										Work Location Type{" "}
										<span className="text-danger ">*</span>
									</label>

									<ReactSelect
										options={workLocation}
										// onChange={handleWorkLoc}
										// onChange={(option) => handleFieldChange(setworkLocationSearch, option ? option.value : "")} // Track changes
										onChange={(option) => handleFieldChange(setworkLocationSearch, option ? option.value : "", "workLocationSearch")}
										value={
											workLocation.find(
												(option) => option.value === workLocationSearch
											) || null
										}
										placeholder="Select Work Location Type"
										styles={customStyles}
										classNamePrefix="react-select"
										className="form-control"
										isClearable
									// onInputChange={(inputValue) => setworkLocationSearch(inputValue)}
									// invalid={display && workLocationSearch === ""}
									/>
									{display && !workLocationSearch ? (
										<span className="error_msg_lbl">
											Select Work Location Type{" "}
										</span>
									) : null}
								</div>
							</div>

							{/* ....................... 5 Row ........................ */}
							<div className="post-form-row my-0">
								{/* ........ Job type........ */}
								<div className="post-form-group placeholder-from-react-select">
									<label htmlFor="about">
										Job Type <span className="text-danger ">*</span>
									</label>

									<ReactSelect
										options={jobTypeList}
										// onChange={handleJobType}
										// onChange={(option) => handleFieldChange(setjobTypeSearch, option ? option.value : "")} // Track changes
										onChange={(option) => handleFieldChange(setjobTypeSearch, option ? option.value : "", "jobTypeSearch")}
										value={
											jobTypeList.find(
												(option) => option.value === jobTypeSearch
											) || null
										}
										placeholder="Select Job Type"
										styles={customStyles}
										classNamePrefix="react-select"
										className="form-control"
										isClearable
									// onInputChange={(inputValue) => setjobTypeSearch(inputValue)}
									// invalid={display && cityListSearch === ""}
									/>
									{display && !jobTypeSearch ? (
										<span className="error_msg_lbl">Select Job Type </span>
									) : null}
								</div>

								{/* ........ City ........ */}
								<div className=" post-form-group placeholder-from-react-select">
									<label htmlFor="about">
										City <span className="text-danger"> *</span>
									</label>

									<ReactSelect
										options={cityList}
										// onChange={handleCitySelect}
										// onChange={(option) => handleFieldChange(setcityListSearch, option ? option.value : "")} // Track changes
										onChange={(option) => handleFieldChange(setcityListSearch, option ? option.value : "", "cityListSearch")}
										value={
											cityList.find(
												(option) => option.value === cityListSearch
											) || null
										}
										placeholder="Search & Select City"
										onInputChange={handleCityInputChange}
										styles={customStyles}
										classNamePrefix="react-select"
										className="form-control"
										isClearable
									/>
									{display && !cityListSearch ? (
										<span className="error_msg_lbl">Search & Select City </span>
									) : null}
								</div>
							</div>

						</div>

						{/* <div className="post-job-form ">
              <div className="post-form-group placeholder-from-react-select">
                <label htmlFor="job-title" className="post-form-label mt-0">
                  Requirement <span className="text-danger">*</span>
                </label>

                <textarea
                  id="job-requirement"
                  className="post-description-input"
                  placeholder="Type The Job Requirement Here..."
                  value={requirement}
                  // onChange={(e) => setRequirement(e.target.value)}
                  onChange={(e) => handleFieldChange(setRequirement, e.target.value)}
                ></textarea>
                {display && !requirement ? (
                  <span className="error_msg_lbl">Enter Requirement</span>
                ) : null}
              </div>
            </div> */}
						<div className="post-job-form">
							<div className="post-form-group placeholder-from-react-select">
								<label htmlFor="job-requirement" className="post-form-label mt-0">
									Requirement <span className="text-danger">*</span>
								</label>

								<ReactQuill
									id="job-requirement"
									className="post-description-input"
									theme="snow"
									value={requirement}
									// onChange={(value) => handleFieldChange(setRequirement, value)}
									onChange={(value) => handleFieldChange(setRequirement, value, "requirement")}
									placeholder="Type The Job Requirement Here..."

								/>

								{display && !requirement.trim() && (
									<span className="error_msg_lbl">Enter Requirement</span>
								)}
							</div>
						</div>

						<div className="post-job-description py-0">
							<div className="post-form-group placeholder-from-react-select">

								<label htmlFor="job-description" className="post-form-label mt-0">
									Job Description <span className="text-danger">*</span>
								</label>

								<ReactQuill
									id="job-description"
									className="post-description-input"
									placeholder="Type The Job Description Here..."
									value={jobDescription}
									// onChange={(e) => setjobDescription(e.target.value)}
									// onChange={(value) => handleFieldChange(setjobDescription, value)}
									onChange={(value) => handleFieldChange(setjobDescription, value, "jobDescription")}
								/>
								{display && !jobDescription ? (
									<span className="error_msg_lbl">Enter Job Description</span>
								) : null}
							</div>
						</div>

						<Button
							// className="mainBtn apply-job mb-3 mt-2"
							onClick={(e) => AddJobCompany(e)}
							className={`btn btn-primary mainBtn apply-job mb-3 mt-2 ${!formChanged || isSubmitting ? "disabled" : "enabled"}`}
							disabled={!formChanged || isSubmitting}
							style={{ pointerEvents: formChanged ? "auto" : "none", border: "none" }}
						>
							Submit
						</Button>
						{/* /*... 3  */}
					</div>
				</div>
			</div>

			<Modal show={showBulkModal}
				onHide={handleCloseBulkModal}
				size="md" centered
				className="Bulk-Upload-Excel-Modal"
			>
				<Modal.Header >
					<Modal.Title>Bulk upload excel file</Modal.Title>
					<CloseSharpIcon className="pointer" onClick={handleCloseBulkModal} />

				</Modal.Header>
				<Modal.Body>
					{/* <div className="placeholder-from-react-select d-flex align-center" >
						<input
							type="checkbox"
							className="mt-1"
							style={{ width: "40px" }}
							checked={isChecked}
							onChange={(e) => setIsChecked(e.target.checked)}
						/>
						<label htmlFor="duplicateSkip" >Duplicate Skip</label>
					</div> */}
					<div className="row">
						<div className="col-md-6">
							<div className="pt-3 ">
								<div className="d-flex justify-content-center">
									<input
										type="file"
										accept=".xlsx,.xls"
										onChange={handleFileUpload}
										style={{
											marginTop: "15px",
											// border: "1px solid #ddd",
											padding: "5px 10px",
											borderRadius: "5px",
											cursor: "pointer",
										}}
									/>
								</div>

							</div>
						</div>
						{/* <div className="col-md-6 pt-4">
							<div><h6 className="f-700">Duplicate skip</h6></div>
							<label class="switch mt-1">
								<input
									type="checkbox"
									checked={duplicateSkip}
									onChange={handleToggle}
								/>
								<span class="slider round"></span>
							</label>
						</div> */}
						<div className="col-md-6 duplicate-skip-cont d-flex">
							<h6 className="f-700 me-2">Duplicate skip</h6>
							<span>
								<label class="switch mt-1">
									<input
										type="checkbox"
										checked={duplicateSkip}
										onChange={handleToggle}
									/>
									<span class="slider round"></span>
								</label>
							</span>

						</div>
					</div>


				</Modal.Body>
				<div className="d-flex justify-content-center pe-3 pb-3">
					{/* <div className="add-class-submit-button d-flex justify-content-center">
						<Button variant="secondary" onClick={handleCloseBulkModal}>
							Close
						</Button>
						<div className=" ms-3">
							<a onClick={uploadFile}
								className={`btn btn-primary mainBtn apply-job mb-3 mt-2`}
								style={{ height: "40px", pointerEvents: formChanged ? "auto" : "none", border: "none" }}
							>
								Upload
							</a>
						</div>
					</div> */}

					<div className="add-class-submit-button d-flex justify-content-center">
						<Button variant="secondary" onClick={handleCloseBulkModal}>
							Close
						</Button>
						{/* <div className="khojPrimaryBtn ms-3"
							style={{ height: "40px" }}
						>
							<a href="#/" onClick={uploadFile}
								className={`btn ${!formChangedBulk || isSubmittingBulk ? "disabled" : "enabled"}`}
								// disabled={!formChanged || isSubmitting}
								style={{ pointerEvents: formChangedBulk ? "auto" : "none", border: "none" }}
							>
								Upload
							</a>
						</div> */}
						{/* <div className="ms-2">
							<button
								type="button"
								className="f-500 mt-2 downloadbtn khojPrimaryBtn"
								onClick={uploadFile}
								style={{
									width: "120px",
									opacity: isDownloading ? 0.6 : 1,
									display: "flex",
									alignItems: "center",
									justifyContent: "center",
									gap: "6px"
								}}
							>
								<span>{isDownloading ? "Uploading" : "Upload"}</span>
								{isDownloading && <span className="loader"></span>}
							</button>
						</div> */}
						<div className="khojPrimaryBtn ms-3"
							style={{ height: "40px", width: "120px" }}
						>
							<a href="#/" onClick={uploadFile}
								className={`btn ${!formChangedBulk || isSubmittingBulk ? "disabled" : "enabled"}`}
								// disabled={!formChanged || isSubmitting}
								style={{ pointerEvents: formChangedBulk ? "auto" : "none", border: "none" }}
							>
								{/* Upload */}
								<span>{isDownloading ? "Uploading" : "Upload"}</span>
								{isDownloading && <span className="loader"></span>}
							</a>
						</div>
					</div>
				</div>
				<hr />
				<div className="d-flex justify-content-center align-items-baseline">

					<p className="text-center mb-2">Download reference file</p>
					<div className="col-md-3">
						<div className="khoDwnlodBtn ms-3">
							{/* <Tooltip title="Download reference file" arrow> */}
							<p onClick={downloadExcel}>
								Download
							</p>
							{/* </Tooltip> */}
						</div>
					</div>
				</div>

				<div className="d-flex justify-content-center">

					{/* <div className="col-md-6 ">
								<div className="Excel-File-Box"
									style={{
										width: "100%",
										padding: "8px",
										border: "1px solid #ddd",
										borderRadius: "8px",
										textAlign: "center",
										backgroundColor: "#f9f9f9",
										marginBottom: "15px",
									}}
								>
									<p style={{ margin: "0", fontWeight: "bold" }}>Wok.xlsx</p>
								</div>
							</div> */}

				</div>
			</Modal>
		</>
	);
};

export default PostCard;
